module.exports = __webpack_public_path__ + "img/MoreHeroesNeeded_Question_x2.aa6ab4ff.png";